import { styled } from "@mui/material/styles";

// Styled components
interface WrapperLoaderProps {
  isSmall?: boolean;
  withDarkBackground?: boolean;
}

const WrapperLoader = styled("div", {
  shouldForwardProp: (prop) => prop !== "isSmall" && prop !== "withDarkBackground",
})<WrapperLoaderProps>(({ isSmall, withDarkBackground }) => ({
  position: isSmall ? "absolute" : "fixed",
  top: 0,
  left: 0,
  zIndex: 19,
  width: "100%",
  height: "100%",
  background: withDarkBackground ? "#0D1724" : "transparent",
  borderRadius: isSmall ? 20 : 0,
}));

interface LoaderSpinnerProps {
  isSmall?: boolean;
}

const LoaderSpinner = styled("div", {
  shouldForwardProp: (prop) => prop !== "isSmall",
})<LoaderSpinnerProps>(({ isSmall }) => ({
  position: "absolute",
  top: isSmall ? "calc(50% - 15px)" : "calc(50% - 30px)",
  left: isSmall ? "calc(50% - 15px)" : "calc(50% - 30px)",
  border: isSmall ? "3px solid #f3f3f3" : "6px solid #f3f3f3",
  borderRadius: "50%",
  borderTop: isSmall ? `3px solid #83E2C2` : `6px solid #83E2C2`,
  width: isSmall ? 30 : 60,
  height: isSmall ? 30 : 60,
  animation: "spin 2s linear infinite",
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
}));

// Loader Component
interface LoaderProps {
  isSmall?: boolean;
  withDarkBackground?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ isSmall, withDarkBackground }) => (
  <WrapperLoader isSmall={isSmall} withDarkBackground={withDarkBackground}>
    <LoaderSpinner isSmall={isSmall} />
  </WrapperLoader>
);

export default Loader;
